import {Subscription} from 'rxjs';

import IPlayer from '../../../Player/Interfaces/IPlayer';

import createActiveStream                  from './Streams/createActiveStream';
import createCaptionsMenuButtonTapStream   from './Streams/createCaptionsMenuButtonTapStream';
import createExitFullscreenStream          from './Streams/createExitFullscreenStream';
import createFocusChangeStream             from './Streams/createFocusChangeStream';
import createFrameStatusChangeStream       from './Streams/createFrameStatusChangeStream';
import createFullscreenTapStream           from './Streams/createFullscreenTapStream';
import createIdleStream                    from './Streams/createIdleStream';
import createSettingsCloseTapStream        from './Streams/createSettingsCloseTapStream';
import createWatermarkStatusStream         from './Streams/createWatermarkStatusStream';
import subscribeToActive                   from './Subscribers/subscribeToActive';
import subscribeToCaptionsMenuButtonTap    from './Subscribers/subscribeToCaptionsMenuButtonTap';
import subscribeToConsumerToggleControls   from './Subscribers/subscribeToConsumerToggleControls';
import subscribeToConsumerToggleFullscreen from './Subscribers/subscribeToConsumerToggleFullscreen';
import subscribeToExitFullscreen           from './Subscribers/subscribeToExitFullscreen';
import subscribeToFocusChange              from './Subscribers/subscribeToFocusChange';
import subscribeToFrameStatusChange        from './Subscribers/subscribeToFrameStatusChange';
import subscribeToFullscreenTap            from './Subscribers/subscribeToFullscreenTap';
import subscribeToIdle                     from './Subscribers/subscribeToIdle';
import subscribeToSettingsCloseTap         from './Subscribers/subscribeToSettingsCloseTap';
import subscribeToWatermarkStatus          from './Subscribers/subscribeToWatermarkStatus';

const connectFrameSubscriptions = (player: IPlayer): Subscription[] => {
    const {config, frame, playback, volume} = player.state.stores;
    const {uiEvents$} = player.ui;

    const active$ = createActiveStream(uiEvents$, player.solution.mediaEvents$, frame.update$, playback.update$);

    return [
        subscribeToFrameStatusChange(createFrameStatusChangeStream(frame.update$), config),
        subscribeToExitFullscreen(createExitFullscreenStream(window, frame.update$), frame),
        subscribeToFullscreenTap(createFullscreenTapStream(uiEvents$), frame),
        subscribeToIdle(createIdleStream(
            active$,
            uiEvents$,
            frame.update$,
            playback.update$,
            volume.update$
        ), frame),
        subscribeToActive(active$, frame),
        subscribeToFocusChange(createFocusChangeStream(uiEvents$), frame),
        subscribeToConsumerToggleControls(player.consumerInput.toggleControls$, frame),
        subscribeToConsumerToggleFullscreen(player.consumerInput.toggleFullscreen$, frame),
        subscribeToWatermarkStatus(createWatermarkStatusStream(config.update$, playback.update$), frame),
        subscribeToCaptionsMenuButtonTap(createCaptionsMenuButtonTapStream(uiEvents$), frame),
        subscribeToSettingsCloseTap(createSettingsCloseTapStream(uiEvents$, frame.update$), frame)
    ];
};

export default connectFrameSubscriptions;